
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.875 1.5h-3.75a.18.18 0 01-.156-.091 2.871 2.871 0 00-4.942 0 .18.18 0 01-.152.09h-3.75A1.125 1.125 0 000 2.626v14.25A1.125 1.125 0 001.125 18h12.75A1.125 1.125 0 0015 16.875V2.625A1.125 1.125 0 0013.875 1.5zM12.75 12.195c0 .447-.16.88-.45 1.22l-1.44 1.68a1.875 1.875 0 01-1.424.654H2.625a.375.375 0 01-.375-.375V4.124a.375.375 0 01.375-.374h9.75a.375.375 0 01.375.375v8.07z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.5 6.187H7.125a.563.563 0 000 1.125H10.5a.563.563 0 100-1.125zM10.5 8.812H7.125a.563.563 0 000 1.125H10.5a.563.563 0 100-1.125zM10.5 11.437H7.125a.562.562 0 000 1.125H10.5a.563.563 0 000-1.125zM4.5 7.5a.75.75 0 100-1.5.75.75 0 000 1.5zM4.5 10.124a.75.75 0 100-1.5.75.75 0 000 1.5zM4.5 12.75a.75.75 0 100-1.5.75.75 0 000 1.5z","fill":"currentColor"}})])
          )
        }
      }
    